import angular from 'angular';
import MerchantTermsModalComponent from './merchantTermsModal.component';

const MerchantTermsModalModule = angular.module('tinaba.common.merchantTermsModal', [])

.component('merchantTermsModal', MerchantTermsModalComponent);

export default MerchantTermsModalModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/merchantTermsModal/merchantTermsModal.js
 **/